import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import {
    routes as commonRoutes
} from '@/common/common-router.js'
import {
    getMenus as commonMenus
} from '@/common/required-method/get-menus.js'

import Template from '@/common/template.vue'

import TableSimple from '@/components/model/table-simple/table-simple.vue'
import Error401 from '@/components/error/401'
import Error404 from '@/components/error/404'

export const routes = [
    ...commonRoutes,
    {
        path: '/model',
        component: Template,
        meta: {
            title: '模板',
            icon: 'experiment',
            breadcrumb: ['模板'],
            routeName: '/model',
            cachedName: 'model'
        },
        children: [{
            path: 'table-simple',
            component: TableSimple,
            meta: {
                title: '简单表格',
                icon: 'layout',
                breadcrumb: ['模板', '简单表格'],
                routeName: '/model/table-simple',
                cachedName: 'table_simple'
            }
        }]
    },
    {
        path: '/401',
        component: Error401,
        meta: {
            title: '',
            icon: '',
            breadcrumb: ['401'],
            routeName: '/401',
            cachedName: ''
        }
    },
    {
        path: '/',
        redirect: '/index',
        meta: {
            title: '',
            icon: '',
            breadcrumb: [],
            routeName: '/',
            cachedName: ''
        }
    },
    {
        path: '*',
        component: Error404,
        meta: {
            title: '',
            icon: '',
            breadcrumb: ['404'],
            routeName: '/404',
            cachedName: ''
        }
    }
]

export const getMenus = async(role, stationId) => {
    let commons = await commonMenus(role, stationId)
    return [
        ...commons,
        // '/model/table-simple',
        '/401',
        '/404'
    ]
}

export const router = new VueRouter({
    routes
})
